export type NewRelicErrorPrefix =
  | 'ACCOUNT-SUSPENDED-PAGE'
  | 'APP'
  | 'AUTH-PAGES'
  | 'FIRST-PARTY-REVIEWS'
  | 'MARKET-INTELLIGENCE'
  | 'OMNI-LOCATION'
  | 'SOCIAL-MANAGEMENT'
  | 'WIDGET-PREVIEW'
  | 'WIDGETS'
  | 'BILLING-AND-PAYMENTS'

export function sendNewRelicError(prefix: NewRelicErrorPrefix, messageOrError: string | Error) {
  //In development, log to console for easier debugging
  if (process.env.NODE_ENV === 'development') {
    if (messageOrError instanceof Error) {
      console.error(`[${prefix}]`, messageOrError)
    } else {
      console.error(`[${prefix}] - ${messageOrError}`)
    }
    return
  }

  if (messageOrError instanceof Error) {
    messageOrError.message = `[${prefix}] - ${messageOrError.message}`
    window?.newrelic?.noticeError?.(messageOrError)
  } else {
    window?.newrelic?.noticeError?.(new Error(`[${prefix}] - ${messageOrError}`))
  }
}

export function sendNewRelicErrorFactory(prefix: NewRelicErrorPrefix) {
  return (messageOrError: string | Error) => {
    sendNewRelicError(prefix, messageOrError)
  }
}
